// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZaRV","type":"styles_type__WCIo1","choices":"styles_choices__xGTIf"};